enum FileStateEnum {
  "DRAFT" = "DRAFT",
  "ORG_READY" = "ORG_READY",
  "COMMUNITY" = "COMMUNITY",
}

export default FileStateEnum;
